export default __webpack_public_path__ + "static/media/pic3.0fe944d5.jpg";